import { render, staticRenderFns } from "./InstaLogoBase64.vue?vue&type=template&id=67c8a7bc&scoped=true"
import script from "./InstaLogoBase64.vue?vue&type=script&lang=js"
export * from "./InstaLogoBase64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c8a7bc",
  null
  
)

export default component.exports